<div class="space-y-6">
  <!-- ══════════ Designs ══════════ -->
  <app-voucher-designs-panel />

  <form [formGroup]="designForm" class="space-y-6">
    <section hlmCard>
      <div hlmCardHeader>
        <h2 hlmCardTitle>Pflichtangaben &amp; Gültigkeit</h2>
        <p hlmCardDescription>
          Gilt für alle Designs. Alles andere auf dem Gutschein, etwa Adresse oder Logo, legst du im
          Editor des jeweiligen Designs fest.
        </p>
      </div>

      <div hlmCardContent class="space-y-3">
        <div hlmItem variant="outline" class="flex-col items-stretch gap-2">
          <div class="flex w-full items-start gap-3">
            <div hlmItemContent>
              <span hlmItemTitle>QR-Code auf jedem Design</span>
              <span hlmItemDescription
                >Damit prüfen Kunden Guthaben und Gültigkeit per Scan, und du löst den Gutschein mit
                einem Scan ein. Empfohlen.</span
              >
            </div>
            <div hlmItemActions>
              <hlm-switch
                inputId="require_qr_code_on_voucher"
                aria-label="QR-Code auf jedem Design"
                formControlName="require_qr_code_on_voucher" />
            </div>
          </div>
          @if (!designForm.get('require_qr_code_on_voucher')?.value) {
            <div hlmAlert variant="warning">
              <ng-icon name="lucideTriangleAlert" />
              <p hlmAlertTitle>Ohne QR-Code nur per Code einlösbar</p>
              <p hlmAlertDescription>
                Ein Design ohne QR-Code lässt sich nur einlösen, indem du den Gutscheincode unter
                „Gutschein einlösen“ eintippst. Kunden können Guthaben und Gültigkeit dann nicht per
                Scan prüfen. Ein Design darf den QR-Code weiterhin enthalten.
              </p>
            </div>
          }
        </div>

        <div hlmItem variant="outline" class="flex-col items-stretch gap-2">
          <div class="flex w-full items-start gap-3">
            <div hlmItemContent>
              <span hlmItemTitle>„Gültig bis“-Datum auf jedem Design</span>
              <span hlmItemDescription
                >So sehen Beschenkte direkt auf dem Gutschein, bis wann er gilt.</span
              >
            </div>
            <div hlmItemActions>
              <hlm-switch
                inputId="require_expiry_on_voucher"
                aria-label="„Gültig bis“-Datum auf jedem Design"
                formControlName="require_expiry_on_voucher" />
            </div>
          </div>
          @if (!designForm.get('require_expiry_on_voucher')?.value) {
            <p hlmMuted class="text-xs">
              Designs dürfen das Datum weglassen. Der Gutschein läuft trotzdem ab; das Datum steht
              weiterhin in der Gutscheinübersicht.
            </p>
          }
        </div>

        @if (missingDateExtendsValidity) {
          <div hlmAlert variant="warning">
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>
              Ohne Ablaufdatum auf jedem Gutschein gelten Gutscheine mindestens
              {{ yearsLabel(minValidityYears(false)) }}
            </p>
            <p hlmAlertDescription>
              @if (datePrinted) {
                Das Ablaufdatum ist nicht mehr auf jedem Design erforderlich, ein Design ohne Datum
                kann also jederzeit gewählt werden.
              } @else {
                Das Design, das du gerade verwendest, druckt kein Ablaufdatum.
              }
              {{ validityWithoutDateRule }} Neue Gutscheine sind deshalb
              {{ yearsLabel(effectiveValidityYears) }} gültig.
            </p>
          </div>
        }

        <div hlmItem variant="outline" class="flex-col items-stretch gap-2">
          <div class="flex w-full flex-col gap-3 sm:flex-row sm:items-start">
            <div hlmItemContent>
              <label hlmItemTitle for="voucher_validity_years">Gültigkeit neuer Gutscheine</label>
              <span hlmItemDescription
                >Neue Gutscheine gelten bei dir mindestens {{ yearsLabel(legalMinValidityYears) }}.
                Du kannst sie länger gültig machen, aber nicht kürzer.</span
              >
            </div>
            <div hlmItemActions>
              <hlm-native-select
                selectId="voucher_validity_years"
                formControlName="voucher_validity_years">
                <option hlmNativeSelectOption value="">
                  Mindestfrist ({{ yearsLabel(legalMinValidityYears) }})
                </option>
                @for (years of validityYearOptions; track years) {
                  <option hlmNativeSelectOption [value]="years.toString()">
                    {{ yearsLabel(years) }}
                  </option>
                }
              </hlm-native-select>
            </div>
          </div>
          <p hlmMuted class="text-xs">
            Gilt für Gutscheine, die ab jetzt verkauft oder erstellt werden. Bereits ausgegebene
            Gutscheine behalten ihr Ablaufdatum.
          </p>
        </div>

        <p hlmMuted class="text-xs">
          Fehlt dem Design, das du gerade verwendest, eine Pflichtangabe, siehst du das ganz oben
          auf dieser Seite.
        </p>
      </div>

      <div hlmCardFooter class="justify-end border-t pt-4">
        <app-save-button
          #pdfSaveButton
          size="sm"
          [disabled]="!designForm.valid || !formChanged"
          [loading]="loading"
          (clickEvent)="onSubmitPdfSettings(pdfSaveButton)" />
      </div>
    </section>
  </form>
</div>
